import http from "./http-common";

/**
 * Links a directory user as the medical partner primary account (partner.userId + user.medicalPartnerId).
 * Does not confirm replace — caller must confirm when overwriting an existing primary.
 */
export async function linkPrimaryUserToPartner(partnerId, userId, requestConfig = {}) {
  const pid = String(partnerId);
  const uid = String(userId);
  await http.put(`/api/v1/medical-partners/${pid}`, { userId: uid }, requestConfig);
  const userResponse = await http.get(`/api/v1/user/${uid}`);
  const currentUser = userResponse.data?.data || userResponse.data;
  const updateData = {
    medicalPartnerId: pid,
  };
  if (currentUser.role !== "admin" && currentUser.role !== "medical_partner") {
    updateData.role = "medical_partner";
  }
  if (currentUser.contactPartnerId) {
    updateData.contactPartnerId = null;
  }
  await http.put(`/api/v1/user/${uid}`, updateData);
  return currentUser;
}

export function contactPersonNameFromUser(u) {
  if (!u) return "";
  const parts = [u.first_name, u.last_name].filter((p) => p != null && String(p).trim() !== "");
  const line = parts.map((p) => String(p).trim()).join(" ").trim();
  return line || (u.email ? String(u.email).trim() : "");
}

export function contactPersonEmailFromUser(u) {
  if (!u?.email) return "";
  return String(u.email).trim();
}

export function contactIdentityPayloadFromUser(u) {
  const email = contactPersonEmailFromUser(u);
  const name = contactPersonNameFromUser(u);
  return {
    contact_person_name: name || null,
    contact_person_email: email || null,
  };
}
